import axios from "@axios";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((traffic) => ({
        value: traffic.id,
        label: traffic.request,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {
    async export({ commit }, params) {
      try {
        console.log(params);
        const response = await axios.get(`v1/totem-logs`, {
          params,
          responseType: 'arraybuffer',
        });
        if (!response.data) {
          return [];
        }
        if (params?.action === 'export') {
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });

          const url = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;

          const filename = response.headers['content-disposition']
            ? response.headers['content-disposition'].split('filename=')[1]
            : 'exported-file.xlsx';

          link.setAttribute('download', filename);

          document.body.appendChild(link);
          link.click();
          link.remove();

          const notification = {
            id: filename,
            progress: 100,
            completed: true,
            view: 'Traffic',
            url: url,
            download: filename,
            title: 'Reporte de Traffic',
            body: 'Descarga completa',
            error: false,
            timestamp: new Date().toLocaleString(),
          };
          store.dispatch('grid/updateDownloadNotification', notification);
        } else {
          commit('setData', response.data.data);
          return response.data;
        }
      } catch (error) {
        console.error('Error during export:', error);
        const notification = {
          id: 'error-export',
          progress: 0,
          completed: false,
          view: 'Traffic',
          title: 'Error en la exportación',
          body: 'Hubo un error al intentar descargar el archivo.',
          error: true,
          timestamp: new Date().toLocaleString(),
        };
        store.dispatch('grid/updateDownloadNotification', notification);
      }
    },
    async getAll({ commit }, params) {
      const response = await axios.get(`v1/totem-logs`, {
        params,
        responseType: params?.action == "export" ? "blob" : "json",
      });

      if (!response.data) {
        return [];
      }
      if (params?.action == "export") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        const { t } = useI18nUtils();
        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: "Traffic",
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: "Reporte Traffic",
          body: "Descarga completa",
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };
        store.dispatch("grid/updateDownloadNotification", notification);
      } else {
        commit("setData", response.data.data);
        return response.data;
      }
    },
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
